import { useMemo } from 'react';
import { schoolCategories } from '@/data/schoolCategories';
import { communityCategories } from '@/data/communityCategories';
import { FlyerCategories, FlyerCategory } from '@/types/flyer';

interface UseCategoriesReturn {
  schoolCategories: FlyerCategories;
  communityCategories: FlyerCategories;
  allCategories: FlyerCategories;
  getCategoryById: (id: string) => FlyerCategory | undefined;
  getCategoriesByType: (type: 'school' | 'community') => FlyerCategories;
}

export const useCategories = (): UseCategoriesReturn => {
  const allCategories = useMemo(() => {
    return [...schoolCategories, ...communityCategories];
  }, []);

  const getCategoryById = useMemo(() => {
    return (id: string): FlyerCategory | undefined => {
      return allCategories.find(category => category.id === id);
    };
  }, [allCategories]);

  const getCategoriesByType = useMemo(() => {
    return (type: 'school' | 'community'): FlyerCategories => {
      return type === 'school' ? schoolCategories : communityCategories;
    };
  }, []);

  return {
    schoolCategories,
    communityCategories,
    allCategories,
    getCategoryById,
    getCategoriesByType,
  };
};
